/*exported GENThemeTools*/

/*
 Support functions used throughout
 */

/**
 * GENThemeTools library
 */
const GENThemeTools = (function ($) {
	'use strict';

	let my = {};

	/**
	 * Set height of element to fill window
	 *
	 * @param args object with following properties:
	 *      fillElement: jQuery element to adjust height of to fill window
	 *      onScreenElements: array of jQuery elements which should also be on screen (e.g. header)
	 *      minHeight: minimum height of element - height will not be adjusted to less than this
	 * @return bool true if height was set, false otherwise
	 */
	my.fillHeight = function (args) {
		let subtracts = 0;
		let i = 0;
		while (args.onScreenElements.length > 1 && i <= arguments.length) {
			if (args.onScreenElements[i].outerHeight(true)) {
				subtracts += args.onScreenElements[i].outerHeight(true);
			}
			i++;
		}

		let newHeight = $(window).height() - subtracts;

		if (newHeight > args.minHeight) {
			args.fillElement.outerHeight(newHeight);
			return true;
		} else {
			return false;
		}
	};

	my.getScrollOffset = function () {
		if ($('#responsive-check').height()) {

			let primaryHeight = $('.nav-primary').height() || 0;
			let secondaryHeight = $('.nav-secondary').height() || 0;

			return primaryHeight + secondaryHeight;
		} else {
			return 0;
		}
	};


	/**
	 * Wrapper for js scrollTo which takes into account our fixed header
	 *
	 * @param $el
	 * @param duration
	 * @param extraOffset
	 */
	my.scrollTo = function ($el, duration, extraOffset = 0) {
		duration = typeof duration !== 'undefined' ? duration : 750;

		//requires default jQuery
		jQuery.scrollTo($el, {
			duration: duration,
			offset: {left: 0, top: -my.getScrollOffset() - extraOffset},
		});
	};

	return my;

})(GEN$);

/*
Prototype functions
 */

/**
 * Convert camelCase to dashed-case
 *
 * @returns {string}
 */
/*jshint -W121 */
String.prototype.camelCaseToDashed = function () {
	'use strict';
	return this.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
};

/*
ES polyfill functions
 */

/**
 * Object.assign()
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
 */
if (typeof Object.assign !== 'function') {
	// Must be writable: true, enumerable: false, configurable: true
	Object.defineProperty(Object, 'assign', {
		value: function assign(target) { // .length of function is 2
			'use strict';
			if (target === null) { // TypeError if undefined or null
				throw new TypeError('Cannot convert undefined or null to object');
			}

			var to = Object(target);

			for (var index = 1; index < arguments.length; index++) {
				var nextSource = arguments[index];

				if (nextSource != null) { // Skip over if undefined or null
					for (var nextKey in nextSource) {
						// Avoid bugs when hasOwnProperty is shadowed
						if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
							to[nextKey] = nextSource[nextKey];
						}
					}
				}
			}
			return to;
		},
		writable: true,
		configurable: true,
	});
}
